<template>
  <div class="h-full p-12 mx-auto bg-gray-100 rounded-lg">
    <div class="max-w-xl">
      <FormulateForm
        name="createSegment"
        v-model="formValues"
        @submit="createSegment"
        class="mb-6"
      >
        <h1 class="font-bold text-3xl mb-8">
          Create a new Segment
        </h1>

        <FormulateInput
          name="name"
          type="text"
          label="Segment name"
          placeholder="Name"
          validation="required"
        />
        <FormulateErrors />
        <base-button type="submit" :loading="creating">
          Create
        </base-button>
      </FormulateForm>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      creating: false,
      formValues: {},
    };
  },
  computed: {
    ...mapGetters('company', ['currentCompany']),
  },
  methods: {
    async createSegment(data) {
      try {
        this.creating = true;
        const createdSegment = await this.$api.post(
          `companies/${this.currentCompany.id}/segments/`,
          data
        );
        this.$store.commit('company/segment/addSegment', createdSegment.data);
        this.$store.dispatch(
          'company/segment/changeSegment',
          createdSegment.data.id
        );
        this.$router.push({ name: 'segment-admin-general' });
      } catch (error) {
        this.$formulate.handle(error, 'createSegment');
      } finally {
        this.creating = false;
      }
    },
  },
};
</script>
